export default "__VITE_ASSET__CaPinNjY__"